import { isValidUrl } from '../routes/urls';

export const getFileNameByUrl = (url: string) => {
    const pathname = isValidUrl(url) ? new URL(url).pathname : url;
    return pathname.substring(pathname.lastIndexOf('/') + 1);
};
